import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class SystemEventsModule {
    constructor() {
        this.systemEvents = [];
        this.count = 0;
        this.axiosError = null;
    }
    setData(systemEvents) {
        this.systemEvents = systemEvents;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.systemEvents;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.systemEvents.get(options);
            this.setData(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
        }
    }
}
__decorate([
    State()
], SystemEventsModule.prototype, "systemEvents", void 0);
__decorate([
    State()
], SystemEventsModule.prototype, "count", void 0);
__decorate([
    State()
], SystemEventsModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], SystemEventsModule.prototype, "setData", null);
__decorate([
    Mutation()
], SystemEventsModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], SystemEventsModule.prototype, "setError", null);
__decorate([
    Getter()
], SystemEventsModule.prototype, "list", null);
__decorate([
    Getter()
], SystemEventsModule.prototype, "total", null);
__decorate([
    Getter()
], SystemEventsModule.prototype, "errorList", null);
__decorate([
    Action()
], SystemEventsModule.prototype, "get", null);
